import { ChangeDetectorRef, Component, EventEmitter, Input, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { DataBindingDirective, GridDataResult, SelectionEvent } from '@progress/kendo-angular-grid';
import { TextBoxComponent } from '@progress/kendo-angular-inputs';
import { forkJoin } from 'rxjs';
import { EMDMICONS } from 'src/app/features/common/constants/icon-pack.constant';
import { mwoBuildModel } from 'src/app/interfaces/mwo';
import { commonService } from 'src/app/services/common.service';
import { ExportService } from 'src/app/services/export.service';
import { mwoService } from 'src/app/services/mwo.service';
import { process } from "@progress/kendo-data-query";
import { Router } from '@angular/router';
import { ColumnConfig, FieldValidation, ImportData } from 'src/app/features/common/models/column-config.model';
import { PMService } from '../../../service/pm.service';

@Component({
  selector: 'app-acd-mwo-build',
  templateUrl: './acd-mwo-build.component.html',
  styleUrl: './acd-mwo-build.component.scss'
})
export class AcdMwoBuildComponent {

  crNo = 0;
  iconPacks = EMDMICONS;

  @Input() set setCRNo(crNo: number) {
    if (crNo != null && crNo > 0) {
      this.crNo = crNo;
    }
  }

  crDetails :  any ={}

  isUserHaveAccess: boolean = true;

  @Input() set setCrDetails(crDetails: any) {
    let admin= sessionStorage.getItem('admin');
    let specialist = sessionStorage.getItem('specialist');
    if(specialist != 'true' || admin != 'true') {
    if (crDetails) {
      this.crDetails = crDetails;
      this.isUserHaveAccess = crDetails.isUserCanAccessRequest ?? false;
      this.commonService.styleApplyForNonAccessUser(this.renderer, this.isUserHaveAccess, ['mwoBuildGrid'], ['exportMWOBuild', 'backStepNavigation'], ['exportMWOBuild', 'clearAllInBuild', 'backStepNavigation']);
    } else {
      this.isUserHaveAccess = false;
    }
  }
  }

  @Output() stepNavigateTo = new EventEmitter<string>();

  mwoViewData = new Array<mwoBuildModel>();
  mwoOGData = new Array<mwoBuildModel>();
  mwoData = new Array<mwoBuildModel>();
  ExportData = new Array<mwoBuildModel>();

  WoClassification = new Array<string>;
  IntegralCriticalTask = [];
  validateFlag: any = [];
  ShutdownClassification: any = [];
  ShutdownCode = new Array<string>;
  PrimaryDiscipline = new Array<string>;
  PerformanceStandard = ["CHC", "CPR", "<BLANK>"];

  readyForUndoList = new Array<mwoBuildModel>();
  readyForRedoList = new Array<mwoBuildModel>();

  public selectedIds: Set<number> = new Set<number>();
  isUndoClicked = false;
  isValueChanged = false;
  fieldList: any[] = ['equipTagNumber', 'mwoShortDescription', 'mwoProblemDescription', 'jobPlanNumber', 'areaOwnerCode', 'assignedExecutionCoordinatorCode', 'leadCraft', 'woClassification', 'primaryDiscipline', 'integrityCriticalTask', 'performanceStandard', 'shutDownCode', 'shutdownClassification', 'validateFlag', 'fileName', 'url', 'fileDescription', 'textattachment'];

  mandatoryFieldList: any[] = ['equiptagnumber', 'mwoshortdescription', 'mwoproblemdescription', 'jobplannumber', 'areaownercode', 'assignedexecutioncoordinatorcode', 'leadcraft', 'woclassification', 'primarydiscipline', 'integritycriticaltask', 'performancestandard', 'shutdowncode', 'shutdownclassification', 'validateflag', 'filename', 'url', 'filedescription', 'textattachment'];
  rowSelected: boolean = false;

  showFileUploadPopup: boolean = false;
  public popupOffset: { top: number, left: number } = { top: 0, left: 0 }
  anchorElement: any;
  popUpHeadertext: string = "";

  showJobPlanPopup: boolean = false;
  showEquipmentTagPopup: boolean = false;
  showLeadCraft: boolean = false;
  showMwoExist: boolean = false;
  showAssignedExecutionPopup: boolean = false;
  showAreaCode: boolean = false;
  AddToCrClicked: boolean = false;
  mwoError: boolean = false;
  mwoPopupGridData = [];
  mwoEquipmentPopupData = JSON.parse(JSON.stringify(this.mwoPopupGridData));
  searchString: any;
  mwoEquipmentPopupView = JSON.parse(JSON.stringify(this.mwoPopupGridData));
  mwoAssignPopupView = JSON.parse(JSON.stringify(this.mwoPopupGridData));
  mwoAssignPopupData = JSON.parse(JSON.stringify(this.mwoPopupGridData));
  mwoErrorTextList: any[] = [];

  @ViewChild(DataBindingDirective)
  dataBinding!: DataBindingDirective;

  mwoExistGrid = [{
    MWO: 1234,
    Description: "already included in ",
    CR: 12345
  }];

  popupGridColumn: ColumnConfig[] = [
    { field: 'type', title: 'Service Type', width: 120, isSearchProperty: true },
    { field: 'description', title: 'Description', width: 280, isSearchProperty: true },
  ];

  equipmentSelectColumn: ColumnConfig[] = [
    { field: 'equipTag', title: 'Equipment Tag Number', width: 120, isSearchProperty: true },
    { field: 'equipDesc', title: 'Equipment Tag Description', width: 250, isSearchProperty: true },
    { field: 'equipSubClass', title: 'Equipment Sub Class', width: 120, isSearchProperty: false },
  ]

  jobplanSelectColumn: ColumnConfig[] = [
    { field: 'jobPlanNumber', title: 'Job Plan Number', width: 300, isSearchProperty: true, showSpecialStatus: true },
    { field: 'branch', title: 'Branch', width: 120, isSearchProperty: true },
  ]

  commonSelectColumn: ColumnConfig[] = [
    { field: 'code', title: 'Code', width: 150, isSearchProperty: true },
    { field: 'description', title: 'Description', width: 200, isSearchProperty: true },
  ]


  popupDataList!: GridDataResult;
  skip = 0;
  pageSize = 5;
  searchText: string = "";

  constructor(private mwoService: mwoService, private commonService: commonService,
    private exportService: ExportService, private cdr: ChangeDetectorRef, private pmService: PMService,
    private renderer: Renderer2
  ) { }

  ngOnInit() {
    this.calculateOffset();
    this.getMwoBuildData();
    // this.getMwoBuildDropDowns();
  }
  
  getMwoBuildDropDowns() {
    this.mwoService.getMwoDropdownAllData().subscribe({
      next: (response: any) => {
        if (response!=null) {
          this.WoClassification = response.Classification1;
          this.PrimaryDiscipline = response.PrimaryDiscipline;
          this.ShutdownCode = response.ShutdownCode1;         
          this.ShutdownClassification = ['(blank)',...response.ShutdownClassification1];
          this.IntegralCriticalTask = response.IntegrityCriticalTask1;
          this.validateFlag = ['(blank)', ...response.ValidateFlag1];
          if (!(this.ShutdownClassification).includes('(blank)')) {
            this.ShutdownClassification.push('(blank)');
          }
          if (!(this.validateFlag).includes('(blank)')) {
            this.validateFlag.push('(blank)');
          }
        }
      },
      error: (error: any) => {
       
      }
    });
  }

 /*  getMwoBuildDropDowns() {
    let requestList = [
      this.mwoService.getMwoDropdownData('Wr01_Woclassification1'),
      this.mwoService.getMwoDropdownData('Wr02_PrimaryDiscipline'),
      this.mwoService.getMwoDropdownData('Wr04_ShutdownCode1'),
      this.mwoService.getMwoDropdownData('Wr05_ShutdownClassification1'),
      this.mwoService.getMwoDropdownData('Wr14_IntegrityCriticalTask1'),
      this.mwoService.getMwoDropdownData('Shno_ValidateFlag1'),
    ];

    forkJoin(requestList).subscribe({
      next: (response: any) => {
        if (requestList.length == response.length) {

          this.WoClassification = response[0];
          this.PrimaryDiscipline = response[1];
          this.ShutdownCode = response[2];
          this.ShutdownClassification = response[3];
          this.IntegralCriticalTask = response[4];
          this.validateFlag = response[5];
        }
      }
    })
  } */

  public getMwoBuildData() {
    this.mwoService.getMwodata(this.crNo).subscribe((data: any) => {
      if (data) {

        data = data.map((x: any) => {
          x.fieldChangedList = [];
          x.errorList = [];
          x.leadCraft = x.leadCraft?.trim();
          x.branch = x.branch?.trim();
          x.performanceStandardList = [];
          x.lastEquipTagNumber = x.equipTagNumber;
          if (x.modifiedFields != null && x.modifiedFields != '') {
            x.fieldChangedList = x.modifiedFields.split(";");
            this.readyForUndoList.push(x);
          }
          if(x.performanceStandard.trim() == '') {
            x.performanceStandard = '(blank)';
          }

          if (x.validateFlag.trim() == '') {
            x.validateFlag = '(blank)';
          }

          return x;
        });

        if (data.length > 0) {
          this.getMwoBuildDropDowns();

        }

        if (!this.isNewlyCreated && !this.isRecordDeleted) {
          this.mwoViewData = JSON.parse(JSON.stringify(data.filter((x: any) => x.isstaging)));
          this.mwoOGData = JSON.parse(JSON.stringify(data.filter((x: any) => !x.isstaging)));
          this.mwoData = JSON.parse(JSON.stringify(this.mwoViewData));

          this.ExportData = data.filter((x: any) => x.isstaging).map((x: any) => {
            return {
              emdmKey: x.emdmKey,
              acdAction: x.acdAction,
              mwoNumber: x.mwoNumber,
              equipTagNumber: x.equipTagNumber,
              mwoShortDescription: x.mwoShortDescription,
              mwoProblemDescription: x.mwoProblemDescription,
              jobPlanNumber: x.jobPlanNumber,
              areaOwnerCode: x.areaOwnerCode,
              assignedExecutionCoordinatorCode: x.assignedExecutionCoordinatorCode,
              leadCraft: x.leadCraft?.trim(),
              woClassification: x.woClassification,
              primaryDiscipline: x.primaryDiscipline,
              integrityCriticalTask: x.integrityCriticalTask,
              performanceStandard: x.performanceStandard,
              integrityCriticalRanking: x.asIntegrityCriticalRanking,
              shutdownCode: x.shutdownCode,
              shutdownClassification: x.shutdownClassification,
              validateFlag: x.validateFlag,
              branch: x.branch?.trim(),
              fileName: x.fileName,
              url: x.url,
              fileDescription: x.fileDescription,
              txtAttachment: x.textattachment
            }
          });
        }
        else if (this.isRecordDeleted) {
          if (this.deletedChangeItemId > 0) {
            this.mwoData = this.mwoData.filter((x: any) => x.changeitemId != this.deletedChangeItemId);
            this.mwoViewData = this.mwoViewData.filter((x: any) => x.changeitemId != this.deletedChangeItemId);
          }
          this.ExportData = [...this.mwoViewData];
          this.isRecordDeleted = false;
          this.deletedChangeItemId = 0;
        }
        else {
          let newData = data.filter((d: any) => !this.mwoViewData.some((x: any) => x.changeitemId == d.changeitemId));

          this.mwoViewData = [...this.mwoViewData, ...JSON.parse(JSON.stringify(newData))];
          this.mwoData = [...this.mwoData, ...JSON.parse(JSON.stringify(newData))];

          let newExportData = newData.filter((x: any) => x.isstaging).map((x: any) => {
            return {
              emdmKey: x.emdmKey,
              acdAction: x.acdAction,
              mwoNumber: x.mwoNumber,
              equipTagNumber: x.equipTagNumber,
              mwoShortDescription: x.mwoShortDescription,
              mwoProblemDescription: x.mwoProblemDescription,
              jobPlanNumber: x.jobPlanNumber,
              areaOwnerCode: x.areaOwnerCode,
              assignedExecutionCoordinatorCode: x.assignedExecutionCoordinatorCode,
              leadCraft: x.leadCraft?.trim(),
              woClassification: x.woClassification,
              primaryDiscipline: x.primaryDiscipline,
              integrityCriticalTask: x.integrityCriticalTask,
              performanceStandard: x.performanceStandard,
              integrityCriticalRanking: x.asIntegrityCriticalRanking,
              shutdownCode: x.shutdownCode,
              shutdownClassification: x.shutdownClassification,
              validateFlag: x.validateFlag,
              branch: x.branch?.trim(),
              fileName: x.fileName,
              url: x.url,
              fileDescription: x.fileDescription,
              txtAttachment: x.textattachment
            }
          });

          this.ExportData = [...this.ExportData, ...newExportData];
          this.isNewlyCreated = false;
        }

        let equipTagNumbers = this.mwoViewData.filter((x: any) => x.equipTagNumber != null && x.equipTagNumber != '').map((x: any) => x.equipTagNumber);

        equipTagNumbers.splice(0, 0, '');
        if (data.length > 0) {
          this.getPerformanceStandardList(equipTagNumbers);
        }

        this.cdr.detectChanges();

        // setTimeout(() => { this.commonService.styleApplyForNonAccessUser(this.renderer, this.isUserHaveAccess, ['mwoBuildGrid'], ['exportMWOBuild', 'backStepNavigation'], ['exportMWOBuild', 'clearAllInBuild', 'backStepNavigation']); }, 0);
      }
    });
  }

  getPerformanceStandardList(equipTagNumbers: string[]) {
    if (this.isUserHaveAccess) {
      this.mwoService.getPerfomanceStandardNew(equipTagNumbers).subscribe({
        next: (response: any) => {
          if (response) {
            this.PerformanceStandard = response;

            this.mwoViewData.forEach((x: any) => {
              x.performanceStandardList = this.PerformanceStandard.filter((y: any) => x.equipTagNumber?.toLowerCase() == y.tagNumber?.toLowerCase()).map((y: any) => y.code);
              if (x.performanceStandard == null || x.performanceStandard == '') {
                x.performanceStandard = '(blank)';
              }
              x.performanceStandardList.push('(blank)');
              console.log(x.performanceStandardList);
              console.log(x.performanceStandard);
            });
          }
        }
      });
    }
  }

  getPerformanceStandardListForIndex(equipTagNumbers: string[], index: number) {
    this.mwoService.getPerfomanceStandardNew(equipTagNumbers).subscribe({
      next: (response: any) => {
        if (response) {
          this.PerformanceStandard = response;
          this.mwoViewData[index].performanceStandardList ??= [];

          if (index > -1 && index <= (this.mwoViewData.length - 1)) {
            this.mwoViewData[index].performanceStandardList = this.PerformanceStandard.filter((y: any) => this.mwoViewData[index].equipTagNumber?.toLowerCase() == y.tagNumber?.toLowerCase()).map((y: any) => y.code);
            if (this.mwoViewData[index].performanceStandard == null || this.mwoViewData[index]?.performanceStandard == '') {
              this.mwoViewData[index].performanceStandard = '(blank)';
            }
          }
          this.mwoViewData[index].performanceStandardList.push('(blank)');
        };
      }
    });
  }

  clearAll() {
    let flagReceived = confirm("All MWOs, not just selected, will be cleared from CR. Are you sure?");
    const notificationMessage = this.mwoViewData.length + "  record(s) cleared from CR successfully.";
    if (flagReceived) {
      const reqData = {
        crid: this.crNo,
        flag: "SelectedAll",
        changeitemId: ""
      }

      this.mwoService.deleteMwo(reqData).subscribe((data) => {
        this.getMwoBuildData();
        this.commonService.showNotificationMessage(notificationMessage, "success", "center");
        this.rowSelected = false;
      })
    }
  }

  clearSelected() {
    let flagReceived = confirm("All selected records but the ones already added to CR will be cleared. Are you sure?");
    if (flagReceived) {
      const reqData = {
        crid: this.crNo,
        flag: "Selected",
        changeitemId: Array.from(this.selectedIds).join(',')
      }
      const notificationMessage = this.selectedIds.size + " record(s) cleared from CR successfully.";
      this.mwoService.deleteMwo(reqData).subscribe((data) => {
        this.commonService.showNotificationMessage(notificationMessage, "success", "center");
        this.getMwoBuildData();
        this.selectedIds.clear();
      })
    }
  }

  clickImport(event: any) {
    this.popupTitle = "Import new changes to change request #" + this.crNo;
    this.popupHeight = 250;
    this.popupWidth = 500;

    this.fieldValidationInput = [
      {
        title: 'EMDM Key',
        field: 'emdmKey',
        validations: ["required"]
      },
      {
        field: 'equipTagNumber',
        title: 'Equip Tag Number',
        validations: ["required"]
      },
      {
        title: 'ACD Action',
        field: 'acdAction',
        validations: ["required"]
      },
      {
        field: 'mwoNumber',
        title: 'MWO Number',
        validations: ["required"]
      },
      {
        field: 'mwoShortDescription',
        title: 'MWO Short Description',
        validations: ["required"]
      },
      {
        field: 'mwoProblemDescription',
        title: 'MWO Problem Description',
        validations: ["required"]
      },
      {
        field: 'jobPlanNumber',
        title: 'Job Plan Number',
        validations: ["required"]
      },
      {
        field: 'areaOwnerCode',
        title: 'Area Owner Code',
        validations: ["required"]
      },
      {
        field: 'assignedExecutionCoordinatorCode',
        title: 'Assigned Execution Coordinator Code',
        validations: []
      },
      {
        field: 'leadCraft',
        title: 'Lead Craft',
        validations: []
      },
      {
        field: 'woClassification',
        title: 'WO Classification',
        validations: []
      },
      {
        field: 'primaryDiscipline',
        title: 'Primary Discipline',
        validations: []
      },
      {
        field: 'integrityCriticalTask',
        title: 'Integrity Critical Task',
        validations: []
      },
      {
        field: 'performanceStandard',
        title: 'Performance Standard',
        validations: []
      },
      {
        field: 'integrityCriticalRanking',
        title: 'Integrity Critical Ranking',
        validations: []
      },
      {
        field: 'shutdownCode',
        title: 'Shutdown Code',
        validations: []
      },
      {
        field: 'shutdownClassification',
        title: 'Shutdown Classification',
        validations: []
      },
      {
        field: 'validateFlag',
        title: 'Validate Flag',
        validations: []
      },
      {
        field: 'branch',
        title: 'Branch',
        validations: []
      },
      {
        field: 'fileName',
        title: 'File Name',
        validations: []
      },
      {
        field: 'url',
        title: 'Url',
        validations: []
      },
      {
        field: 'fileDescription',
        title: 'File Description',
        validations: []
      },
      {
        field: 'textattachment',
        title: 'Text Attachment',
        validations: []
      },
    ];


    this.showFileUploadPopup = true;
  }

  popupOpenField = "";
  popUpOpenFieldChangeItemId = 0;
  popupShow = false;
  popupTitle = "";
  popupHeight = 440;
  popupWidth = 600;
  searchPlaceHolder = "Search"
  fieldValidationInput!: FieldValidation[];


  openActionPopup(fieldName: string, dataItem: any = null) {
    this.popupOpenField = fieldName;
    this.popUpOpenFieldChangeItemId = dataItem?.changeitemId ?? 0;
    this.popupDataList = { data: [], total: 0 };
    if (this.popupOpenField == 'equipTagNumber') {
      this.popupTitle = "Search Job Plan Number for Tag#" + dataItem.equipTagNumber + " , MWO " + this.getDefaultData(dataItem.mwoNumber, '0');
      this.popupGridColumn = this.equipmentSelectColumn;
      this.searchPlaceHolder = "Search Equipment Tag Number, Description or Subclass";
      this.popupWidth = 800;

      this.getEquipPopupData();
    }
    else if (this.popupOpenField == 'jobPlanNumber') {
      this.popupTitle = "Search Job Plan Number for Tag#" + dataItem.equipTagNumber + " , MWO " + this.getDefaultData(dataItem.mwoNumber, '0');
      this.popupGridColumn = this.jobplanSelectColumn;
      this.searchPlaceHolder = "Search Job Plan Number";
      this.popupWidth = 650;
      this.getJobPlanPopupData();
    }
    else if (this.popupOpenField == 'areaOwnerCode' && dataItem != null) {
      this.popupTitle = "Search Area Owner Code for Tag#" + dataItem.equipTagNumber + " , MWO " + this.getDefaultData(dataItem.mwoNumber, '0') + " Job plan " + this.getDefaultData(dataItem.jobPlanNumber, ''); this.popupGridColumn = this.commonSelectColumn;
      this.searchPlaceHolder = "Insert total or partial Area Owner Code/description to search for";
      this.popupWidth = 600;
      this.getAreaOwnerCodePopupData();
    }
    else if (this.popupOpenField == 'assignedExecutionCoordinatorCode') {
      this.popupTitle = "Search Assigned Execution Coordinator Code for Tag#" + dataItem.equipTagNumber + " , MWO " + this.getDefaultData(dataItem.mwoNumber, '0') + "Job plan " + this.getDefaultData(dataItem.jobPlanNumber, '');
      this.popupGridColumn = this.commonSelectColumn;
      this.searchPlaceHolder = "Insert total or partial Assigned Execution Coordinator code/description to search for";
      this.popupWidth = 600;

      this.getAssignExecPopupData();
    }
    else if (this.popupOpenField == 'leadCraft') {
      this.popupTitle = "Search Lead Craft for Tag#" + dataItem.equipTagNumber + " , MWO " + dataItem.mwoNumber + "Job plan " + this.getDefaultData(dataItem.jobPlanNumber, ''); this.popupGridColumn = this.commonSelectColumn;
      this.searchPlaceHolder = "Insert total or partial Lead Craft code/description to search for";
      this.popupWidth = 600;
      this.leadCraftPopupData();
    }
  }

  getDefaultData(value: any, returnValue: any) {
    return value == null || value == '' ? returnValue : value;
  }

  closeActionPopup(status: boolean) {
    this.popUpOpenFieldChangeItemId = 0;
    this.popupTitle = "";
    this.popupShow = status;
    this.searchPlaceHolder = "";
    this.popupHeight = 440;
    this.popupWidth = 600;
    this.popupDataList = { data: [], total: 0 };
    this.popupGridColumn = [];

    this.skip = 0;
    this.pageSize = 5;
    this.searchText = "";
  }

  dataItemSelcted(dataItem: any) {

    let viewDataItem = this.mwoViewData.find((x: mwoBuildModel) => x.changeitemId == this.popUpOpenFieldChangeItemId);

    if (dataItem && this.popupOpenField != '' && viewDataItem) {
      if (this.popupOpenField == 'equipTagNumber') {
        viewDataItem.equipTagNumber = dataItem?.equipTag;
        viewDataItem.asIntegrityCriticalRanking = dataItem?.icRank ?? "(blank)";
        this.onValueChange(viewDataItem, 'equipTagNumber', dataItem?.equipTag);

        let viewDataItemIndex = this.mwoViewData.findIndex((x: mwoBuildModel) => x.changeitemId == this.popUpOpenFieldChangeItemId);
        this.getPerformanceStandardListForIndex([dataItem?.equipTag], viewDataItemIndex);
      }
      else if (this.popupOpenField == 'jobPlanNumber') {
        viewDataItem.jobPlanNumber = dataItem?.jobPlanNumber;
        this.onValueChange(viewDataItem, 'jobPlanNumber', dataItem?.jobPlanNumber);
      }
      else if (this.popupOpenField == 'areaOwnerCode') {
        viewDataItem.areaOwnerCode = dataItem?.code;
        this.onValueChange(viewDataItem, 'areaOwnerCode', dataItem?.code);
      }
      else if (this.popupOpenField == 'assignedExecutionCoordinatorCode') {
        viewDataItem.assignedExecutionCoordinatorCode = dataItem?.code;
        this.onValueChange(viewDataItem, 'assignedExecutionCoordinatorCode', dataItem?.code);
      }
      else if (this.popupOpenField == 'leadCraft') {
        viewDataItem.leadCraft = dataItem?.code;
        this.onValueChange(viewDataItem, 'leadCraft', dataItem?.code);
      }
    }

    this.closeActionPopup(false);
  }

  clickExport(event: Event): void {
    let custName = "export_mwo_CR" + this.crNo + "_" + this.commonService.getCurrentUTCDateTime();
    let mwoExportColoumns = ["EMDM Key", "ACD Action", "MWO Number", "Equip Tag Number", "MWO Short Description", "MWO Problem Description", "Job Plan Number", "Area Owner Code", "Assigned Execution Coordinator Code", "Lead Craft", "WO Classification", "Primary Discipline", "Integrity Critical Task", "Performance Standard", "Integrity Critical Ranking", "Shutdown Code", "Shutdown Classification", "Validate Flag", "Branch", "File Name", "Url", "File Description", "Text Attachment"]

    this.exportService.exportExcel(this.ExportData, [mwoExportColoumns], custName);
    this.commonService.showNotificationMessage(
      'file downloaded successfully',
      'success',
      'center'
    );
  }

  imported(data: ImportData) {
    if (data.validationMsgs.length > 0) {
      this.commonService.showNotificationMessage(data.validationMsgs.join("<br>"), "error", "center");
    } else {
      let equipTagNumberByEmdmKey = this.mwoViewData.filter((x: mwoBuildModel) => x?.acdAction?.toLocaleLowerCase() != 'add').map((x: mwoBuildModel) => {
        return {
          emdmKey: x.emdmKey,
          equiptagNumber: x.equipTagNumber?.toString()
        }
      });

      data.data.map((x: any, index: number) => {
        x.rowId = index;
        x.equipTagNumber = equipTagNumberByEmdmKey.find((y: any) => x.emdmKey == y.emdmKey)?.equiptagNumber?.toString() ?? x.equipTagNumber?.toString();
      });

      this.mwoService.ValidateImportMWOBuild(data.data, this.crNo).subscribe({
        next: (response: any) => {
          if (response != null) {
            if (response.errorList?.length > 0) {
              response.errorList.splice(0, 0, [`There is ${response.errorList.length} error field:`]);
              this.commonService.showNotificationMessage(response.errorList.join("<br>"), "error", "center");
            }
            else {
              this.importValid(data);
            }
          }
          this.closePopup();
        },
        error: (error: any) => {

        }
      });
    }
  }

  importValid(data: ImportData) {
    this.readyForUndoList = [];
    this.selectedIds.clear;
    data.data.forEach((x: any) => {
      let isChangeDetected = false;
      let mwoData: any = this.mwoData.find((viewData: mwoBuildModel) => viewData.emdmKey == x.emdmKey);
      let viewData: any = this.mwoViewData.find((viewData: mwoBuildModel) => viewData.emdmKey == x.emdmKey);
      if (mwoData && viewData) {
        Object.keys(x).forEach((key: any) => {
          if (this.mandatoryFieldList.includes(key?.toLocaleLowerCase() ?? "")) {
            if (x[key] != null && x[key] != viewData[key]) {
              if (!viewData.fieldChangedList.includes(key)) {
                viewData.fieldChangedList.push(key);
              }

              if (!isChangeDetected) {
                isChangeDetected = true;
              }

              viewData[key] = x[key];
            }
          }
        });


        if (isChangeDetected && x.acdAction != 'Add') {
          viewData.acdAction = "Change";
          viewData.acdId = this.commonService.setACDID(viewData.acdAction);
        }

        if (isChangeDetected) {
          this.readyForUndoList.push(viewData);
        }
      }
    });
    this.closePopup();
  }


  onSelectionChangeEvent(event: SelectionEvent) {
    this.selectedIds = this.commonService.onGridSelection(this.selectedIds, event, "changeitemId");
  }

  onValueChange(dataItem: any, field: string, event: any) {
    this.isUndoClicked = false;
    this.isValueChanged = true;
    dataItem.fieldChangedList ??= [];
    let index = this.readyForUndoList.findIndex((x: any) => dataItem.changeitemId == x.changeitemId);

    if (index == -1) {
      this.readyForUndoList.push(JSON.parse(JSON.stringify(dataItem)));
    } else {
      this.readyForUndoList[index] = JSON.parse(JSON.stringify(dataItem));
    }

    //event = event == "(blank)" ? "" : event;

    let ogData = this.mwoOGData.find((x: any) => dataItem.changeitemId == x.changeitemId) as { [key: string]: any };;
    if (dataItem.acdAction != 'Add') {
      if (ogData[field] !== event) {
        if (dataItem.fieldChangedList.find((x: string) => x == field) == undefined) {
          dataItem.fieldChangedList.push(field);
        }
      }
      else {
        let index = dataItem.fieldChangedList.findIndex((x: string) => x == field);
        if (index > -1) {
          dataItem.fieldChangedList.splice(index, 1);
        }
      }

      dataItem.acdAction = dataItem.fieldChangedList == 0 ? 'No change' : 'Change';
      dataItem.acdId = this.commonService.setACDID(dataItem.acdAction);
    }

    if (field == 'integrityCriticalTask') {
      dataItem.performanceStandard = '(blank)';
      this.onValueChange(dataItem, 'performanceStandard', '(blank)');
    }
  }

  undoSelected() {
    this.isUndoClicked = true;
    this.selectedIds.forEach((selectedId: any) => {
      let index = this.readyForUndoList.findIndex((x: any) => selectedId == x.changeitemId);
      if (index >= 0) {
        let viewDataIndex = this.mwoViewData.findIndex((x: any) => selectedId == x.changeitemId);
        if (viewDataIndex >= 0) {
          let ogDataItem = this.mwoOGData.find((x: any) => selectedId == x.changeitemId);
          if (ogDataItem) {
            this.mwoViewData[viewDataIndex] = JSON.parse(JSON.stringify(ogDataItem));
            this.mwoViewData[viewDataIndex].fieldChangedList = [];
            this.mwoViewData[viewDataIndex].isstaging = true;
            this.mwoViewData[viewDataIndex].acdAction = 'No change';
            this.mwoViewData[viewDataIndex].acdId = this.commonService.setACDID('No change');

            let data = this.readyForUndoList[index];
            if (data.acdAction != 'Add') {
              this.fieldList.forEach((x: any) => {
                let element = document.getElementById(`${selectedId}_${x}`);
                if (element) {
                  element.classList.remove('backgroundChange');
                }
              });
            }
          }
        }
      }
    });
  }

  undoById(selectedId: number) {
    this.isUndoClicked = true;
    let index = this.readyForUndoList.findIndex((x: any) => selectedId == x.changeitemId);
    if (index >= 0) {
      let viewDataIndex = this.mwoViewData.findIndex((x: any) => selectedId == x.changeitemId);
      if (viewDataIndex >= 0) {
        let ogDataItem = this.mwoOGData.find((x: any) => selectedId == x.changeitemId);
        if (ogDataItem) {
          let performanceStandardList = this.mwoViewData[viewDataIndex].performanceStandardList;
          this.mwoViewData[viewDataIndex] = JSON.parse(JSON.stringify(ogDataItem));
          this.mwoViewData[viewDataIndex].fieldChangedList = [];
          this.mwoViewData[viewDataIndex].isstaging = true;
          this.mwoViewData[viewDataIndex].acdAction = 'No change';
          this.mwoViewData[viewDataIndex].acdId = this.commonService.setACDID('No change');
          this.mwoViewData[viewDataIndex].performanceStandardList = performanceStandardList;
          if (this.mwoViewData[viewDataIndex].acdAction != 'Add') {
            this.fieldList.forEach((x: any) => {
              let element = document.getElementById(`${selectedId}_${x}`);
              if (element) {
                element.classList.remove('backgroundChange');
              }
            });
          }
        }
      }
    }
  }

  redoSelected() {
    this.isUndoClicked = false;
    this.selectedIds.forEach((selectedId: any) => {
      let index = this.readyForUndoList.findIndex((x: any) => selectedId == x.changeitemId);
      if (index >= 0) {
        let viewDataIndex = this.mwoViewData.findIndex((x: any) => selectedId == x.changeitemId);
        let viewData = this.mwoViewData[viewDataIndex] as { [key: string]: any };

        if (viewDataIndex >= 0) {
          this.mwoViewData[viewDataIndex] = JSON.parse(JSON.stringify(this.readyForUndoList[index]));
          this.mwoViewData[viewDataIndex].fieldChangedList = [];
          this.mwoViewData[viewDataIndex].acdAction = "Change";
          this.mwoViewData[viewDataIndex].acdId = this.commonService.setACDID("Change");

          this.setFieldStylesForRedoOperation(selectedId, index, viewData, viewDataIndex);
        }
      }
    });
  }

  redoById(selectedId: number) {
    this.isUndoClicked = false;
    let index = this.readyForUndoList.findIndex((x: any) => selectedId == x.changeitemId);
    if (index >= 0) {
      let viewDataIndex = this.mwoViewData.findIndex((x: any) => selectedId == x.changeitemId);
      let viewData = this.mwoViewData[viewDataIndex] as { [key: string]: any };

      if (viewDataIndex >= 0) {
        this.mwoViewData[viewDataIndex] = JSON.parse(JSON.stringify(this.readyForUndoList[index]));
        this.mwoViewData[viewDataIndex].fieldChangedList = [];
        this.mwoViewData[viewDataIndex].acdAction = "Change";
        this.mwoViewData[viewDataIndex].acdId = this.commonService.setACDID("Change");

        this.setFieldStylesForRedoOperation(selectedId, index, viewData, viewDataIndex);
      }
    }
  }

  setFieldStylesForRedoOperation(selectedId: number, index: number, viewData: any, viewDataIndex: number) {
    let dataItem = this.readyForUndoList[index] as { [key: string]: any };
    this.fieldList.forEach((field: string) => {
      if (dataItem[field] != viewData[field]) {
        let element = document.getElementById(`${selectedId}_${field}`);
        if (element) {
          element.classList.add('backgroundChange');

          if (this.mwoViewData[viewDataIndex].fieldChangedList.find((x: string) => x == field) == undefined) {
            this.mwoViewData[viewDataIndex].fieldChangedList.push(field);
          }
        }
      }
    });
  }

  isNewlyCreated: boolean = false;
  isRecordDeleted: boolean = false;
  deletedChangeItemId: number = 0;

  addNewMwo() {
    const reqData = {
      crid: this.crNo
    }
    this.mwoService.createNewMwo(reqData).subscribe((data) => {
      if (data === "Success") {
        this.isNewlyCreated = true;
        this.getMwoBuildData();
      }
    });
  }

  deleteNewMwo(dataItem: any) {
    this.deletedChangeItemId = dataItem.changeitemId;
    const reqData = {
      crid: this.crNo,
      flag: "Selected",
      changeitemId: this.deletedChangeItemId.toString()
    }
    this.mwoService.deleteMwo(reqData).subscribe((data) => {
      this.isRecordDeleted = true;
      this.getMwoBuildData();
    });
  }

  searchIconClick(anchor: HTMLElement, textbox: any): void {
    this.anchorElement = anchor;
    this.showJobPlanPopup = true;
  }

  calculateOffset() {
    const popupHeight = 300;
    const popupWidth = 200;
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    this.popupOffset = {
      top: windowHeight / 2,
      left: windowWidth / 2
    }
  }

  closePopup() {
    this.showJobPlanPopup = false;
    this.showFileUploadPopup = false;
    this.showAreaCode = false;
    this.showLeadCraft = false;
    this.showEquipmentTagPopup = false;
    this.showMwoExist = false;
  }

  public OnSelectionChangeEvent(event: SelectionEvent): void {
    if (event.selectedRows && event.selectedRows.length > 0) {
      event.selectedRows.forEach((row) =>
        this.selectedIds.add(row.dataItem.changeitemId)
      );
      this.rowSelected = true;
    }
    if (event.deselectedRows && event.deselectedRows.length > 0) {
      event.deselectedRows.forEach((row) =>
        this.selectedIds.delete(row.dataItem.changeitemId)
      );
      if (this.selectedIds.size === 0) {
        this.rowSelected = false;
      }
    }
  }

  inputChanged(event: any) {
    this.searchString = event;
  }

  popupEquipmentSearch(anchor: TextBoxComponent) {
    this.mwoEquipmentPopupView = process(this.mwoEquipmentPopupData, {
      filter: {
        logic: "or",
        filters: [
          {
            field: "id",
            operator: "contains",
            value: this.searchString,
          },
          {
            field: "Description",
            operator: "contains",
            value: this.searchString,
          }
        ],
      },
    }).data;
    this.dataBinding.skip = 0;
  }

  popupJobPlanSearch(anchor: TextBoxComponent) {
    this.mwoEquipmentPopupView = process(this.mwoEquipmentPopupData, {
      filter: {
        logic: "or",
        filters: [
          {
            field: "id",
            operator: "contains",
            value: this.searchString,
          },
          {
            field: "Description",
            operator: "contains",
            value: this.searchString,
          }
        ],
      },
    }).data;
    this.dataBinding.skip = 0;
  }

  popupAreaOwnerSearch() {
    this.mwoAssignPopupView = process(this.mwoAssignPopupData, {
      filter: {
        logic: "or",
        filters: [
          {
            field: "Code",
            operator: "contains",
            value: this.searchString,
          },
          {
            field: "Description",
            operator: "contains",
            value: this.searchString,
          }
        ],
      },
    }).data;
    this.dataBinding.skip = 0;
  }

  popupDataCLick(data: any) {
    alert(data);
  }

  popupAssignExecCodeSearch(anchor: TextBoxComponent) {
    this.mwoEquipmentPopupView = process(this.mwoEquipmentPopupData, {
      filter: {
        logic: "or",
        filters: [
          {
            field: "id",
            operator: "contains",
            value: this.searchString,
          },
          {
            field: "Description",
            operator: "contains",
            value: this.searchString,
          }
        ],
      },
    }).data;
    this.dataBinding.skip = 0;
  }

  popupSearch(event: any) {

  }

  mwoErrorPopup() {
    this.showMwoExist = true;
  }

  saveMwoBuild() {
    let flagReceived = confirm("Are you sure?");

    let validateMWOExist = false;
    if ("shouldValidateMWOExist" in sessionStorage) {
      validateMWOExist = sessionStorage.getItem("shouldValidateMWOExist")?.toLocaleLowerCase() === "true";
    }

    if (flagReceived) {
      let validateMWOExistPayload = this.mwoViewData?.filter((val: any) => val?.acdAction != 'Add')?.map((x: any) => x.mwoNumber);
      this.mwoErrorTextList = [];
      if (validateMWOExist && validateMWOExistPayload.length > 0) {
        this.pmService.checkMwoNumberExists(this.crNo, validateMWOExistPayload).subscribe({
          next: (response: any) => {
            if (response.length > 0) {
              this.mwoErrorTextList = response;
            } else {
              this.validateMWOBuild();
            }
          },
          error: () => {

          }
        });
      } else {
        this.validateMWOBuild();
      }
    }
  }

  validateMWOBuild() {

    let payload = this.resetData();

    this.mwoService.ValidateMWO(payload, this.crNo).subscribe({
      next: (data: any) => {
        if (data.length > 0) {
          this.mwoViewData.filter((x: any) => {
            x.errorList = [];
          });

          let errorMessages: any[] = data.filter((x: any) => x.errorMessage != '' || x.fieldList != '').map((x: any) => ({
            errorMessage: x.errorMessage, fieldList: x.fieldList, rowNumber: x.rowNumber
          }));

          if (errorMessages.length > 0) {

            errorMessages.filter((x: any) => x.fieldList != null).forEach((x: any) => {
              let fieldList = x.fieldList?.split(";");
              this.mwoViewData[x.rowNumber - 1].errorList = fieldList;

              if (fieldList.includes("performanceStandard") && this.mwoViewData[x.rowNumber - 1].performanceStandard == "") {
                this.mwoViewData[x.rowNumber - 1].performanceStandard = "(blank)";
              }
            });

            let errorMessage = "Please fix highlighted fields:";
            errorMessage += errorMessages.filter((x: any) => x.errorMessage != null).map((error: any) => error.errorMessage);
            this.commonService.showNotificationMessage(errorMessage, "error", "center");
          } else {
            let warningMessages = data.filter((x: any) => x.warningMessage != null && x.warningMessage != '').map((x: any) => x.warningMessage);
            this.saveAndAddToCr(warningMessages);
          }
        }
        else {
          this.saveAndAddToCr();
        }
      }, error: () => {
        this.mwoViewData.filter((x: any) => {
          if (x.performanceStandard == '') {
            x.performanceStandard = "(blank)";
          }
        });
      }
    });
  }

  resetData() {
    let payloadData = JSON.parse(JSON.stringify(this.mwoViewData));

    payloadData.forEach((data: any) => {
      data.modifiedFields = "";
      if (data.performanceStandard == '(blank)') {
        data.performanceStandard = "";
      }
      if (data.fieldChangedList?.length > 0) {
        data.modifiedFields = data?.fieldChangedList?.join(";") ?? "";
      } else {
        data.modifiedFields = "";
      }

      if (data.shutdownClassification == '(blank)') {
        data.shutdownClassification = "";
      }
      if (data.validateFlag == '(blank)') {
        data.validateFlag = "";
      }

    });

    return payloadData;
  }

  saveAndAddToCr(warningMessages: string[] = []) {
    let payload = this.resetData();
    this.mwoErrorTextList = [];
    this.mwoService.saveAndAddToCr(payload, this.crNo).subscribe({
      next: (data: any) => {
        if (warningMessages.length > 0) {
          this.commonService.showNotificationMessage(warningMessages.join("<br>"), "warning", "center", 200, false);;
        } else {
          this.commonService.showNotificationMessage("MWO Header Change added successfully.", "success", "center", 200, false);
        }
        this.stepNavigateTo.emit("Summary");
      }
    });
  }

  addFiles(event: any) {
    // console.log(event);
  }

  backBTNClicked() {
    this.stepNavigateTo.emit('Search');
  }

  popupPageChanged(event: any) {
    this.skip = event.skip;
    this.pageSize = event.pageSize;
    this.searchText = event.searchText;

    if (this.popupOpenField == 'equipTagNumber') {
      this.getEquipPopupData();
    }
    else if (this.popupOpenField == 'leadCraft') {
      this.leadCraftPopupData();
    }
    else if (this.popupOpenField == 'areaOwnerCode') {
      this.getAreaOwnerCodePopupData();
    }
    else if (this.popupOpenField == 'jobPlanNumber') {
      this.getJobPlanPopupData();
    }
    else if (this.popupOpenField == 'assignedExecutionCoordinatorCode') {
      this.getAssignExecPopupData();
    }
  }

  setPopUpDataFromResponse(response: any) {
    if (response && response?.item1?.length > 0) {
      this.popupDataList = {
        data: response.item1,
        total: response.item2
      };
      this.popupShow = true;
    } else {
      this.popupDataList = { data: [], total: 0 };
      this.popupShow = true;
    }
  }

  getEquipPopupData() {
    this.pmService.getRouteTag(this.skip, this.pageSize, this.searchText).subscribe({
      next: (response: any) => {
        this.setPopUpDataFromResponse(response);
      },
      error: () => {
        this.popupDataList = { data: [], total: 0 };
        this.popupShow = true;
      }
    });
  }

  getAssignExecPopupData() {
    this.mwoService.getAssignExecTag(this.skip, this.pageSize, this.searchText).subscribe({
      next: (response: any) => {
        this.setPopUpDataFromResponse(response);
      },
      error: () => {
        this.popupDataList = { data: [], total: 0 };
        this.popupShow = true;
      }
    });
  }

  getJobPlanPopupData() {
    this.mwoService.getJobPlanData(this.skip, this.pageSize, this.searchText).subscribe({
      next: (response: any) => {
        this.setPopUpDataFromResponse(response);
      },
      error: () => {
        this.popupDataList = { data: [], total: 0 };
        this.popupShow = true;
      }
    });
  }

  leadCraftPopupData() {
    this.mwoService.getLeadCraftCode(this.skip, this.pageSize, this.searchText, this.crNo).subscribe({
      next: (response: any) => {
        this.setPopUpDataFromResponse(response);
      },
      error: () => {
        this.popupDataList = { data: [], total: 0 };
        this.popupShow = true;
      }
    });
  }

  getAreaOwnerCodePopupData() {
    this.mwoService.getAreaOwnerCode(this.skip, this.pageSize, this.searchText).subscribe({
      next: (response: any) => {
        this.setPopUpDataFromResponse(response);
      },
      error: () => {
        this.popupDataList = { data: [], total: 0 };
        this.popupShow = true;
      }
    });
  }

  equipTagNumberChange(dataItem: any) {

    dataItem.lastEquipTagNumber ??= "";

    if (dataItem.equipTagNumber != dataItem.lastEquipTagNumber) {
      dataItem.lastEquipTagNumber = dataItem.equipTagNumber;
      this.onValueChange(dataItem, 'equipTagNumber', dataItem.equipTagNumber);
      this.popupOpenField = 'equipTagNumber';
      this.popUpOpenFieldChangeItemId = dataItem?.changeitemId ?? 0;
      dataItem.performanceStandard = '(blank)';
      if (dataItem.equipTagNumber != null && dataItem.equipTagNumber != '')
      { 
      this.pmService.getRouteTag(0, 5, dataItem.equipTagNumber, true).subscribe({
        next: (response: any) => {
          if (response?.item1?.length > 0) {
            let data = response.item1.find((x: any) => x.equipTag?.toLocaleLowerCase() == dataItem.equipTagNumber.toLocaleLowerCase());
            if (data) {
              this.dataItemSelcted(data);
            } else {
              this.commonService.showNotificationMessage('Given equipTagNumber is not valid.', 'error', 'center')
            }
          } else {
            this.commonService.showNotificationMessage('Given equipTagNumber is not valid.', 'error', 'center')
          }
        },
        error: () => {

        }
      });
    }
    }
  }
}
